module.exports = __webpack_public_path__ + "img/logo.a7ed2e5e.png";